@if (survey) {
  <div class="container single-view" id="edit-survey">
    <div class="row">
      <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
        <div id="pre-header-wr">
          <a data-testid="back-btn" appBack [fallbackUrl]="'/surveys/' + surveyId" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'SURVEYS.BTN_BACK_TO_SURVEY' | translate }}</a>
        </div>
      </div>
      <div class="col-12">
        <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
          <div class="title-wr">
            <h1 data-testid="edit-survey-title" class="section-title">{{ 'SURVEYS_UPDATE.TITLE' | translate }}</h1>
          </div>
        </div>
        <hr role="presentation" class="w-full mb-3 mt-6 border-t">
        <div class="view-content-wr">
          <div class="row rounded-card">
            <form data-testid="add-survey-form" class="mt-0" [formGroup]="surveyForm">
              <div class="flex flex-col col-12 mb-2 text-wr">
                <div class="row">
                  <div class="flex flex-col col-12 mb-4">
                    <h2 class="border-b pb-3">{{ 'SURVEYS_CREATE.SURVEY_DETAILS' | translate }}</h2>
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                    <label class="block text-sm" for="name">
                      {{ 'SURVEYS_CREATE.NAME' | translate }}
                      <i class="icon-required-field"></i>
                    </label>
                    <input id="name" type="text" formControlName="name" autocomplete="off" placeholder="{{ 'SURVEYS_CREATE.NAME_PLACEHOLDER' | translate }}">
                    @if (isSurveyNameInvalid) {
                      <small class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  </div>
                </div>
                <hr role="presentation" class="w-full border-t mt-4">
                <!-- Questions -->
                <div formArrayName="questions">
                  @for (questionForm of questionForms; track questionForm; let questionIndex = $index) {
                    <div class="row mb-5" [formGroupName]="questionIndex">
                      <div class="col-12 mb-3 flex flex-wrap items-center">
                        <h3 class="mb-0 mr-1">{{ 'SURVEYS_CREATE.QUESTION' | translate }} #{{ questionIndex + 1 }}</h3>
                        <button type="button" class="btn borderless-btn btn-icon icon-trash" pTooltip="{{ 'SURVEYS_CREATE.REMOVE_QUESTION' | translate }}" tooltipPosition="top" (click)="removeQuestion(questionIndex)" [disabled]="survey.isPublished"></button>
                      </div>
                      <div class="row">
                        <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-8 col-xl-9">
                          <label class="block text-sm" [for]="'question-code-' + questionIndex">
                            {{ 'SURVEYS_CREATE.QUESTION_CODE' | translate }}
                            <i class="icon-required-field"></i>
                          </label>
                          <input [id]="'question-code-' + questionIndex" type="text" formControlName="code" autocomplete="off" placeholder="{{ 'SURVEYS_CREATE.QUESTION_CODE_PLACEHOLDER' | translate }}">
                          @if (isQuestionCodeInvalid(questionIndex)) {
                            <small class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                          }
                        </div>
                        <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 justify-end">
                          <button type="button" class="p-element btn borderless-btn btn-icon icon-translate" (click)="toggleQuestionTranslations(questionIndex)" [disabled]="survey.isPublished">
                            {{ shouldShowQuestionTranslations(questionIndex) ? ('SURVEYS_CREATE.HIDE_TRANSLATIONS_QUESTION' | translate) : ('SURVEYS_CREATE.ADD_TRANSLATIONS_QUESTION' | translate) }}
                          </button>
                        </div>
                        @if (shouldShowQuestionTranslations(questionIndex)) {
                          <div class="col-12 mt-2 mb-5" [formGroup]="getQuestionTranslationsGroup(questionIndex)">
                            <div class="p-4 border-round translations-wr">
                              <div class="mb-4 text-sm uppercase">
                                {{ 'SURVEYS_CREATE.QUESTION_TRANSLATIONS' | translate }}
                              </div>
                              <div class="row">
                                @for (language of languages; track language) {
                                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                                    <label class="block text-sm">{{ language.language | translate }}</label>
                                    <input type="text" [formControlName]="language.code" autocomplete="off">
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        }
                        <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-4 col-xl-3">
                          <label class="block text-sm">{{ 'SURVEYS_CREATE.QUESTION_TYPE' | translate }}</label>
                          <app-custom-dropdown
                            formControlName="questionType"
                            optionLabel="label"
                            optionValue="value"
                            [placeholder]="'SURVEYS_CREATE.SELECT_QUESTION_TYPE_PLACEHOLDER' | translate"
                            [isMultiselect]="false"
                            [showSelectionChips]="true"
                            [showClear]="false"
                            [showSearchbox]="false"
                            [searchMode]="'local'"
                            [options]="questionTypeOptions">
                            <ng-template let-option>
                              {{ option.label | translate }}
                            </ng-template>
                          </app-custom-dropdown>
                        </div>
                        @if (isFixedValuesQuestion(questionIndex)) {
                          <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3">
                            <label class="block text-sm">{{ 'SURVEYS_CREATE.ALLOWS_MULTIPLE_ANSWERS' | translate }}</label>
                            <div class="flex flex-wrap gap-4 mt-3">
                              <div class="flex align-items-center">
                                <p-radioButton formControlName="allowsMultipleAnswers" [inputId]="'allowsMultipleAnswersYes-' + questionIndex" [value]="true"></p-radioButton>
                                <label class="ml-2" [for]="'allowsMultipleAnswersYes-' + questionIndex">{{ 'SURVEYS_CREATE.YES' | translate }}</label>
                              </div>
                              <div class="flex align-items-center">
                                <p-radioButton formControlName="allowsMultipleAnswers" [inputId]="'allowsMultipleAnswersNo-' + questionIndex" [value]="false"></p-radioButton>
                                <label class="ml-2" [for]="'allowsMultipleAnswersNo-' + questionIndex">{{ 'SURVEYS_CREATE.NO' | translate }}</label>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                      <!-- Answers -->
                      @if (isFixedValuesQuestion(questionIndex)) {
                        <fieldset class="p-4 border-round border">
                          <legend class="px-2">{{ 'SURVEYS_CREATE.ANSWER_OPTIONS' | translate }}</legend>
                          <div class="col-12" formArrayName="answerOptions">
                            @for (answerForm of getAnswerOptionForms(questionIndex); track answerForm; let answerIndex = $index) {
                              <div class="row" [formGroupName]="answerIndex">
                                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-8 col-xl-9">
                                  <label class="block text-sm" [for]="'answer-code-' + questionIndex + '-' + answerIndex">
                                    {{ 'SURVEYS_CREATE.ANSWER_CODE' | translate }} #{{ answerIndex + 1 }}
                                    <i class="icon-required-field"></i>
                                    <button type="button" class="btn borderless-btn btn-icon icon-trash" pTooltip="{{ 'SURVEYS_CREATE.REMOVE_ANSWER_OPTION' | translate }}" tooltipPosition="top" (click)="removeAnswerOption(questionIndex, answerIndex)" [disabled]="survey.isPublished"></button>
                                  </label>
                                  <input [id]="'answer-code-' + questionIndex + '-' + answerIndex" type="text" formControlName="code" autocomplete="off" placeholder="{{ 'SURVEYS_CREATE.ANSWER_CODE_PLACEHOLDER' | translate }}">
                                  @if (isAnswerCodeInvalid(questionIndex, answerIndex)) {
                                    <small class="p-error">
                                      {{ 'FORMS.MANDATORY_FIELD' | translate }}
                                    </small>
                                  }
                                </div>
                                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 justify-end">
                                  <button type="button" class="p-element btn borderless-btn btn-icon icon-translate" (click)="toggleAnswerTranslations(questionIndex, answerIndex)" [disabled]="survey.isPublished">
                                    {{ shouldShowAnswerTranslations(questionIndex, answerIndex) ? ('SURVEYS_CREATE.HIDE_TRANSLATIONS_ANSWER' | translate) : ('SURVEYS_CREATE.ADD_TRANSLATIONS_ANSWER' | translate) }}
                                  </button>
                                </div>
                                @if (shouldShowAnswerTranslations(questionIndex, answerIndex)) {
                                  <div class="col-12 mt-3" [formGroup]="getAnswerTranslationsGroup(questionIndex, answerIndex)">
                                    <div class="p-4 border-round translations-wr">
                                      <div class="mb-4 text-sm uppercase">
                                        {{ 'SURVEYS_CREATE.ANSWER_TRANSLATIONS' | translate }}
                                      </div>
                                      <div class="row">
                                        @for (language of languages; track language) {
                                          <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                                            <label class="block text-sm">{{ language.language | translate }}</label>
                                            <input type="text" [formControlName]="language.code" autocomplete="off">
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                }
                              </div>
                            }
                          </div>
                          <div class="col-12 mt-3">
                            <button type="button" class="btn outline-btn" (click)="addAnswerOption(questionIndex)" [disabled]="survey.isPublished">{{ 'SURVEYS_CREATE.ADD_ANSWER_OPTION' | translate }}</button>
                            @if (isAnswerOptionRequired(questionIndex)) {
                              <div class="mt-2">
                                <small class="p-error">{{ 'SURVEYS_CREATE.AT_LEAST_ONE_ANSWER_OPTION_REQUIRED' | translate }}</small>
                              </div>
                            }
                          </div>
                        </fieldset>
                      }
                    </div>
                  }
                </div>
                <div class="row compensate-ml">
                  <div class="col-12">
                    <button type="button" class="btn outline-btn" (click)="addQuestion()" [disabled]="survey.isPublished">{{ 'SURVEYS_CREATE.ADD_QUESTION' | translate }}</button>
                    @if (isQuestionRequired) {
                      <div class="mt-2">
                        <small class="p-error">{{ 'SURVEYS_CREATE.AT_LEAST_ONE_QUESTION_REQUIRED' | translate }}</small>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="row">
            <div class="col-12 mt-6 mb-4 pt-8 border-t">
              <div class="flex items-center justify-end gap-3">
                <button data-testid="add-survey-update-button" class="btn primary-btn" type="button" [disabled]="surveyForm.invalid" (click)="submitForm()" [disabled]="surveyForm.invalid || survey.isPublished">{{ 'SURVEYS_UPDATE.BTN_UPDATE_SURVEY' | translate }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
